import moment from 'moment'
import _ from 'lodash'

export default function constructAvailabilityRange(startDate, endDate, availResponse, hotelCode) {
	let dateRange = []
	let availDates = {}
	let initialStartDate = moment(startDate, 'YYYY-MM-DD')
	let initialEndDate = moment(endDate, 'YYYY-MM-DD').add(1, 'days')
	let priceData = []

	// Construct generic dates based on range
	while (initialStartDate.isBefore(initialEndDate)) {
		dateRange.push(moment(initialStartDate).format('YYYY-MM-DD'))
		initialStartDate = moment(initialStartDate).add(1, 'days')
	}

	// Construct single array of pricing data sorted by date
	for (const availKey in availResponse) {
		const currentAvail = availResponse[availKey]

		if (currentAvail.price) {
			for (const priceKey in currentAvail.price) {
				const currentPrice = currentAvail.price[priceKey]

				if (
					currentPrice.start &&
					currentPrice.end
				) {
					let priceStartDate = moment(currentPrice.start)
					let priceEndDate = moment(currentPrice.end)
					const currency = _.get(currentPrice, 'currencyCode', 'USD')

					while (priceStartDate.isSameOrBefore(priceEndDate)) {
						priceData.push( {
							date: priceStartDate.format('YYYY-MM-DD'),
							price: currentPrice.amountBeforeTax,
							currency: currency,
						})
						priceStartDate.add(1, 'days')
					}
				}
			}
		}
	}

	// Loop dates array to build daily availability objects
	dateRange.forEach((date) => {
		const currentDate = moment(date).format('YYYY-MM-DD')

		let isDayBlocked = false
		let minStay = 1
		let datePrice = null
		let isRangeStart = false

		for (const availKey in availResponse) {
			const availData = availResponse[availKey]
			const availStart = moment(availData.availability.start)
			const availEnd = moment(availData.availability.end)

			if (availStart.isSame(currentDate)) {
				isRangeStart = true
			}

			// Loop dates to match dateRange date to availResponse date range
			if (
				moment(date).isSame(availStart) ||
				moment(date).isBetween(availStart, availEnd) ||
				moment(date).isSame(availEnd)
			) {
				// Update flag true is closed status
				if (
					availData.availability.status === 'ClosedOnArrival' ||
					availData.availability.status === 'Close'
				) {
					isDayBlocked = true
				}

				// Update min stay if minStay status
				if (availData.availability.status === 'MinStay') {
					const minStayRange = availEnd.diff(availStart, 'days')
					minStay = minStayRange
				}
			}
		}

		// Map price by date by key value of currentDate
		datePrice = priceData.filter(function(prices){
			let priceDate = moment(prices.date).format('YYYY-MM-DD')
			return priceDate === currentDate
		})


		// Construct daily avail object
		let availDay = {}

		availDay[hotelCode + '-' + currentDate] = {
			date: currentDate,
			hotelCode: hotelCode,
			isClosedForArrival: isDayBlocked,
			isRangeStart: isRangeStart,
			minimumStay: minStay,
			pricing: datePrice,
		}

		// Combine daily avail objects
		Object.assign(availDates, availDay)
	})

	return availDates
}


// WEBPACK FOOTER //
// ./src/utilities/availability/constructAvailabilityRange.js